<template>
  <div class="business">
    <van-nav-bar
      :title="$t('m.sm_span0')"
      fixed
      placeholder
      :border="false"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="business_con">
      <!-- <p class="business_con_tit">完成实名认证，保障资金安全 !</p> -->
      <p class="business_con_txt"></p>
      <div
        v-if="nextStepIndex == 1"
        style="background: rgb(255, 255, 255); border-radius: 10px; padding: 15px; margin: 30px auto 0px; width: 96%;"
      >
        <div
          style="display:flex;align-items:center;width: 100%;padding:0 20px;"
        >
          <div
            style="background:#F5F5F8;width:40px;border-radius:50%;color:#fff;height:40px;text-align:center;font-size:10px;"
          >
            <img
              style="width: 20px;height: 20px;margin:10px;"
              src="../../assets/images/icon2.png"
              alt=""
            />
          </div>
          <div
            style="background:linear-gradient(to right,#dfdfdf,#dfdfdf);height: 2px;flex:1;margin:0 15px;"
          ></div>
          <div
            style="background:#F5F5F8;width:40px;border-radius:50%;color:#fff;height:40px;text-align:center;font-size:10px;"
          >
            <img
              style="width: 20px;height: 20px;margin:10px;"
              src="../../assets/images/new/ren3.png"
              alt=""
            />
          </div>
        </div>
        <div
          style="display:flex;align-items:center;width: 100%;padding:0 0px;text-align:center;font-size:12px;color:var(--bg-color);margin-top:10px;justify-content: space-between;padding: 0 20px;"
        >
          <!-- <span style="width: 80px;">{{$t('m.sm_span2')}}</span> -->
          <span style="">{{ $t("m.sm_span3") }}</span>
          <span style="">{{ $t("m.sm_span4") }}</span>
        </div>
      </div>
      <div
        class="business_con_pic"
        style="margin-top:10px;"
        v-if="nextStepIndex == 1"
      >
        <div
          style="font-weight:bold;color:#666;font-size:16px;display:flex;align-items:center;"
        >
          <span
            style="width: 3px;height: 18px;margin-right:6px;background-color:var(--bg-color);"
          ></span>
          {{ $t("m.sm_span3") }}
        </div>
        <div class="form">
          <div class="item">
            <div class="label">{{ $t("m.sm_span01") }}</div>
            <div class="input" style="width: 100%;">
              <van-field
                style="border-bottom:1px solid #eee;flex:1;width: 100%;font-size:16px;font-weight:bold;padding-left:0;"
                v-model="form.name"
                label=""
                :placeholder="$t('m.sm_span02')"
                :border="false"
                label-class="label-class"
              />
            </div>
          </div>
          <div class="item" style="margin-top:20px;">
            <div class="label">{{ $t("m.sm_span03") }}</div>
            <div class="input" style="width: 100%;">
              <van-field
                style="border-bottom:1px solid #eee;flex:1;width: 100%;font-size:16px;font-weight:bold;padding-left:0;"
                v-model="form.idcard2"
                label=""
                :placeholder="$t('m.sm_span04')"
                :border="false"
                label-class="label-class"
                @blur="chaeckCard"
              />
            </div>
          </div>
          <div class="auth-upload-block">
            <div class="auth-upload-title">{{ $t("m.sm_span5") }}</div>
            <div class="auth-upload-list">
              <div class="auth-upload-card">
                <div class="auth-upload-label">{{ $t("m.sm_span6") }}</div>
                <div class="auth-upload-preview">
                  <img :src="zhengImg" :class="{ placeholder: !form.id_positive }" />
                  <div class="auth-upload-mask" v-if="!form.id_positive || uploadingFront">
                    {{ uploadingFront ? "上传中..." : "点击上传人像面" }}
                  </div>
                  <van-uploader
                    accept="image/*"
                    :after-read="afterReadForZ"
                    :max-size="10 * 1024 * 1024"
                    @oversize="onOversize"
                  />
                </div>
              </div>
              <div class="auth-upload-card">
                <div class="auth-upload-label">{{ $t("m.sm_span7") }}</div>
                <div class="auth-upload-preview">
                  <img :src="beiImg" :class="{ placeholder: !form.id_back }" />
                  <div class="auth-upload-mask" v-if="!form.id_back || uploadingBack">
                    {{ uploadingBack ? "上传中..." : "点击上传国徽面" }}
                  </div>
                  <van-uploader
                    accept="image/*"
                    :after-read="afterReadForB"
                    :max-size="10 * 1024 * 1024"
                    @oversize="onOversize"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style="padding:0 20px;">
        <button class="business_but" @click="next()" v-if="nextStepIndex == 1">
          {{ $t("m.tijiao") }}
        </button>
      </div>
      <div
        style="background: rgb(255, 255, 255); border-radius: 10px; padding: 15px; margin: 30px auto 0px; width: 96%; display: flex;"
        v-if="nextStepIndex == 2"
      >
        <div
          :style="{
            borderRadius: '10px',
            background: '#fff',
            width: isAuthApproved ? '80%' : '100%'
          }"
        >
          <div style="font-size:16px;font-weight:bold;margin-bottom:10px;">
            {{ $t("m.sm_span8") }}
          </div>
          <div class="auth-result-status" :class="'status-' + authStatus">
            {{ authStatusText }}
          </div>
          <div
            style="display:flex;align-items:center;margin-bottom:0px;height: 30px;"
          >
            <span>{{ $t("m.sm_span01") }}：</span><span>{{ form.name }}</span>
          </div>
          <div style="display:flex;align-items:center;height: 30px;">
            <span>{{ $t("m.sm_span03") }}：</span
            ><span>{{ wayEncipher(form.idcard2) }}</span>
          </div>
          <div class="auth-result-images" v-if="form.id_positive || form.id_back">
            <img v-if="form.id_positive" :src="zhengImg" />
            <img v-if="form.id_back" :src="beiImg" />
          </div>
        </div>
        <div v-if="isAuthApproved" style="width: 20%;">
          <img src="@/assets/images/bg/smrenz.png" />
        </div>
      </div>
    </div>
    <div style="height: 60px;"></div>
    <div
      v-if="shows"
      style="background: rgba(0, 0, 0, 0.5);position: fixed;width: 100%;height: 100%;left:0;top:0;display: flex;align-items: center;justify-content: center;"
    >
      <div
        style="background: rgba(0, 0, 0, 0.7);width:130px;height:130px;border-radius:8px;text-align:center;line-height:130px;color:#fff;font-size:16px;"
      >
        {{ $t("m.tijiaoing") }}
      </div>
    </div>
  </div>
</template>
<script>
import { auth_add, auth_upload } from "@api/chat";
import { Dialog } from "vant";
import { getMyUserInfo } from "@api/user";
// import request from "@utils/request";
import axios from "axios";
export default {
  data: function() {
    return {
      shows: false,
      types: 1,
      active: "1",
      nextStepIndex: 1,
      stepList: [
        {
          id: 1,
          text: "实名认证",
          start: true,
          end: false
        },
        {
          id: 2,
          text: "确认信息",
          start: false,
          end: false
        },
        {
          id: 3,
          text: "提交完成",
          start: false,
          end: false
        }
      ],
      zhengImg: require("@/assets/images/licai/zheng.png"),
      beiImg: require("@/assets/images/licai/bei.png"),
      zhengshow: false,
      beishow: false,
      uploadingFront: false,
      uploadingBack: false,
      ossToken: {},
      imgCount: 0,
      form: {
        name: "",
        idcard: "",
        idcard2: "",
        id_positive: "",
        id_back: ""
      },
      access_token: "",
      area: null,
      authStatus: null,
      authReason: ""
    };
  },

  created: function() {
    getMyUserInfo().then(res => {
      let userInfo = res.data.data;
      this.area = userInfo.area;
      const authStatus =
        userInfo.auth_status === null || userInfo.auth_status === undefined
          ? null
          : Number(userInfo.auth_status);
      this.authStatus =
        authStatus === null ? (userInfo.is_auth == 1 ? 1 : null) : authStatus;
      this.authReason = userInfo.auth_reason || "";
      if (userInfo.is_auth == 1 || authStatus === 0) {
        this.nextStepIndex = 2;
        this.form.name = userInfo.realname;
        this.form.idcard2 = userInfo.idcard;
        this.form.idcard = userInfo.idcard;
      }
      if (userInfo.id_positive) {
        this.form.id_positive = userInfo.id_positive;
        this.zhengImg = userInfo.id_positive_url || userInfo.id_positive;
        this.zhengshow = true;
      }
      if (userInfo.id_back) {
        this.form.id_back = userInfo.id_back;
        this.beiImg = userInfo.id_back_url || userInfo.id_back;
        this.beishow = true;
      }
    });
    // request.get("/shop/sign/status", {}, { login: true });
  },

  computed: {
    authStatusText() {
      const status = Number(this.authStatus);
      if (status === 1) {
        return "认证已通过";
      }
      if (status === 2) {
        return this.authReason || "认证未通过，请重新提交";
      }
      return "已提交，等待后台审核";
    },
    isAuthApproved() {
      return Number(this.authStatus) === 1;
    }
  },

  methods: {
    wayEncipher(val) {
      if (!val) {
        return " ******** ";
      }
      return val.slice(0, 4) + " ******** " + val.slice(-4);
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    fanhui: function() {
      this.$router.go(-1);
    },
    afterReadForZ(file) {
      this.uploadAuthImage(file, "front");
    },
    afterReadForB(file) {
      this.uploadAuthImage(file, "back");
    },
    onOversize() {
      this.$dialog.error("图片大小不能超过10MB");
    },
    uploadAuthImage(file, side) {
      const rawFile = file && file.file ? file.file : null;
      if (!rawFile) {
        this.$dialog.error("请选择要上传的图片");
        return;
      }
      const isFront = side === "front";
      if (isFront) {
        this.uploadingFront = true;
        this.zhengImg = file.content || this.zhengImg;
      } else {
        this.uploadingBack = true;
        this.beiImg = file.content || this.beiImg;
      }
      const formData = new FormData();
      formData.append("file", rawFile);
      formData.append("side", side);
      auth_upload(formData)
        .then(res => {
          const data = res.data.data || {};
          if (!data.url) {
            this.$dialog.error("上传失败,请重试");
            return;
          }
          if (isFront) {
            this.form.id_positive = data.url;
            this.zhengImg = data.full_url || data.url;
            this.zhengshow = true;
          } else {
            this.form.id_back = data.url;
            this.beiImg = data.full_url || data.url;
            this.beishow = true;
          }
        })
        .catch(err => {
          const msg =
            err && err.response && err.response.data && err.response.data.msg
              ? err.response.data.msg
              : "上传失败,请重试";
          this.$dialog.error(msg);
        })
        .finally(() => {
          if (isFront) {
            this.uploadingFront = false;
          } else {
            this.uploadingBack = false;
          }
        });
    },
    ossUpload(file) {
      axios
        .get("/baiduApi/oauth/2.0/token", {
          params: {
            client_id: "oDCFWizTIM746zrbxvlzXPfr",
            client_secret: "vGXeEkk8jpdA7qrW4uYoR5n1qipt1TDF",
            grant_type: "client_credentials"
          }
        })
        .then(response => {
          // handle success
          console.log("上传成功？", response);
          this.access_token = response.data.access_token;
          this.shangchuan(file);
        })
        .catch(error => {
          // handle error
          console.log("上传成功111？", error);
        });
    },
    shangchuan(file) {
      var reader = new FileReader();
      reader.readAsDataURL(file.file);
      let formatdata = "";
      reader.onload = () => {
        formatdata = reader.result;
        formatdata = encodeURIComponent(formatdata);
        console.log("file 转 base64结果：" + formatdata);
        let url =
          "/baiduApi/rest/2.0/ocr/v1/idcard?access_token=" + this.access_token;
        axios
          .post(url, "id_card_side=front" + "&image=" + formatdata, {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          })
          .then(res => {
            console.log("上传成功qqq？", res);
            // let ossImg = ossToken.host + "/" + ossToken.dir + file.file.name;
            // if (type == "0") {
            //   vm.zhengImg = ossImg;
            // }
            // if (type == "1") vm.beiImg = ossImg;

            // vm.imgCount++;
            // this.srcList.push(res.data.resultContent.filename);
          })
          .catch(res => {
            this.$dialog.error(res.response.data.msg);
          });
      };
      reader.onerror = function(error) {
        console.log("Error: ", error);
      };
    },
    imageToBase64(file) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        console.log("file 转 base64结果：" + reader.result);
        this.iconBase64 = reader.result;
      };
      reader.onerror = function(error) {
        console.log("Error: ", error);
      };
    },
    tab_line: function(type) {
      this.types = type;
    },
    async next() {
      let vm = this;

      if (vm.nextStepIndex == 0) {
        console.log(vm.imgCount);
        vm.nextStepIndex = 1;
        vm.changeStepList(vm.nextStepIndex);
        return;
      }

      if (vm.nextStepIndex == 1) {
        if (vm.uploadingFront || vm.uploadingBack) {
          this.$dialog.error("证件照片正在上传，请稍后");
          return;
        }
        if (!vm.form.id_positive || !vm.form.id_back) {
          this.$dialog.error("请上传身份证正反面照片");
          return;
        }
        this.shows = true;

        auth_add({
          name: vm.form.name,
          idcard: vm.form.idcard2,
          id_positive: vm.form.id_positive,
          id_back: vm.form.id_back
        })
          .then(res => {
            this.shows = false;
            this.authStatus = 0;
            this.authReason = "";
            vm.nextStepIndex = 2;
            vm.changeStepList(vm.nextStepIndex);
            if (this.area && this.area != "86") {
              Dialog.alert({
                title: "温馨提示",
                message: "提交以后请联系人工客服审核！",
                theme: "round-button"
              }).then(() => {
                this.$router.push({
                  path: "/customerService"
                });
              });
            }
            return;
          })
          .catch(err => {
            this.shows = false;
            console.log("回调", err);
            // this.$dialog.error(err.msg);
            this.$dialog.error(err.response.data.msg);
          });
      }
    },
    chaeckCard() {
      let vm = this;

      // vm.form.idcard=vm.form.idcard.substring(0,3)****vm.form.idcard.substring(val.length-3)
      vm.form.idcard = vm.form.idcard2;
      // vm.form.idcard2 = vm.form.idcard2.replace(/^(.{6})(?:\w+)(.{4})$/, "\$1********\$2")
    },
    changeStepList(index) {
      let vm = this;
      vm.stepList[index - 1].end = true;
      vm.stepList[index].start = true;
      if (index == vm.stepList.length - 1) {
        vm.stepList[index].end = true;
      }
    },
    checkIdentity(identity) {
      var reg = /^[1-9]{1}[0-9]{14}$|^[1-9]{1}[0-9]{16}([0-9]|[xX])$/;
      if (reg.test(identity)) {
        return true;
      } else {
        return false;
      }
    },
    gohome() {
      this.$router.replace({
        name: "Index"
      });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .business .van-hairline--bottom::after {
  border-bottom-width: 0px;
}
.business /deep/ .van-nav-bar {
  box-shadow: 0 0 0 #ccc;
  background-color: rgba(0, 0, 0, 0);
}
.business /deep/ .van-nav-bar__title {
  color: #fff;
}
.business /deep/ .van-icon {
  color: #fff;
}
.jiangli_top {
  width: 100%;
  height: 45px;
  line-height: 45px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
}
.jiangli_top img {
  height: 30px;
  width: 30px;
  position: absolute;
  left: 0px;
}
.jiangli_top p {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  text-align: center;
}
.act-num {
  background: #1664fc !important;
  color: white !important;
}

.act-line {
  background: #1664fc !important;
}

.act-text {
  color: #797979 !important;
}
/deep/ .van-field__label {
  width: 0;
}
.auth-upload-block {
  margin-top: 24px;

  .auth-upload-title {
    color: #333;
    font-size: 15px;
    font-weight: bold;
    margin-bottom: 12px;
  }

  .auth-upload-list {
    display: grid;
    grid-template-columns: 1fr;
    gap: 14px;
  }

  .auth-upload-card {
    width: 100%;
  }

  .auth-upload-label {
    color: #666;
    font-size: 13px;
    margin-bottom: 8px;
  }

  .auth-upload-preview {
    position: relative;
    width: 100%;
    height: 150px;
    overflow: hidden;
    border: 1px dashed #d8d8d8;
    border-radius: 8px;
    background: #f8f8fa;
  }

  .auth-upload-preview img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    margin-top: 0;
  }

  .auth-upload-preview img.placeholder {
    object-fit: contain;
    padding: 18px;
    opacity: 0.55;
  }

  .auth-upload-mask {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    height: 34px;
    line-height: 34px;
    color: #fff;
    font-size: 13px;
    text-align: center;
    background: rgba(0, 0, 0, 0.5);
    pointer-events: none;
  }
}
.auth-result-images {
  display: flex;
  gap: 8px;
  margin-top: 10px;

  img {
    width: 50%;
    height: 72px;
    object-fit: cover;
    border-radius: 6px;
    margin-top: 0;
  }
}
.auth-result-status {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  margin-bottom: 8px;
  padding: 4px 10px;
  border-radius: 14px;
  background: #fff7e6;
  color: #d46b08;
  font-size: 13px;
  font-weight: bold;
}
.auth-result-status.status-1 {
  background: #f0fff4;
  color: #16a34a;
}
.auth-result-status.status-2 {
  background: #fff1f0;
  color: #dc2626;
}
/deep/.van-uploader {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  transform: none;
  opacity: 0;

  width: 100% !important;
  height: 100% !important;

  .van-uploader__wrapper {
    width: 100% !important;
    height: 100% !important;

    .van-uploader__upload {
      width: 100% !important;
      height: 100% !important;
      margin: 0 !important;
    }

    .van-uploader__input {
      width: 100% !important;
      height: 100% !important;
      cursor: pointer;
    }
  }
}

.step {
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  margin: 0 auto;

  .item {
    flex: 1;
    height: 60px;
    // display: flex;
    // align-items: center;
    position: relative;

    .num {
      width: 20px;
      height: 20px;
      background: #f0f0f2;
      border-radius: 50%;
      text-align: center;
      line-height: 20px;
      color: #b2b2b2;
      font-size: 13px;
      font-weight: bold;
      position: relative;

      .text {
        position: absolute;
        left: 50%;

        bottom: -26px;
        transform: translate(-50%, 0px);
        font-size: 12px;
        font-weight: bold;
        color: #b2b2b2;
        width: auto;
        white-space: nowrap;
      }
    }

    .line {
      height: 3px;
      background: #f0f0f2;
      flex: 1;
    }

    .line2 {
      height: 3px;
      flex: 1;
      background: #f0f0f2;
    }
  }

  .item2 {
    width: 20px;
    height: 20px;
    background: #f0f0f2;
    border-radius: 50% !important;
    text-align: center;
    line-height: 20px;
    color: #b2b2b2;
    font-size: 13px;
    font-weight: bold;

    position: relative;

    .num {
      border-radius: 50%;
    }

    .text {
      position: absolute;
      left: 50%;

      bottom: -26px;
      transform: translate(-50%, 0px);
      font-size: 12px;
      font-weight: bold;
      color: #b2b2b2;
      width: auto;
      white-space: nowrap;
    }
  }
}

/deep/.form {
  margin-top: 20px;

  .item {
    width: 100%;
    align-items: center;
    padding-left: 10px;

    .label {
      width: 100%;
      color: #333;
      font-size: 15px;
      // font-weight: bold;
      text-align: justify;
      text-justify: inter-ideograph;
      display: flex;
      justify-content: space-between;
      font-weight: bold;
      // display: flex;
      // align-items: center;
    }
  }
}

.rzjg {
  width: 100%;
  height: 200px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .img {
    // position: absolute;
    width: 100px;
    height: 100px;
    // top: 50%;
    // left: 50%;
    // transform: translate(-50%,-50%);
    object-fit: contain;
  }

  .text {
    font-size: 12px;
    color: #b2b2b2;
    // position: absolute;
    // width: 100px;
    // height: 100px;
    // top: 60%;
    // left: 50%;
    // transform: translate(-50%,-50%);
  }
}
</style>

<style lang="less" scoped>
.business {
}

.business_con_pic_tit {
  font-size: 18px;
  font-weight: bold;
  color: #000;
}

.business_con_block {
  position: relative;
}

.business_con_block p {
  font-size: 14px;
  color: #666;
}

.business_con {
  padding: 10px 0px;
  margin-top: -46px;
  background-image: url(../../assets/images/bg/8.png);
  background-repeat: no-repeat;
  background-size: 100% 220px;
  padding-top: 60px;
}

.business_con_pic {
  margin-top: 0px;
  background: #fff;
  border-radius: 8px;
  padding: 15px;
}

.business_con img {
  width: 100%;
  margin-top: 8px;
}

.business_con_tit {
  font-size: 20px;
  font-weight: bold;
  color: #000;
  margin-top: 20px;
}

.business_con_txt {
  font-size: 14px;
  color: #666;
  margin-top: 8px;
}

.business_top {
  line-height: 45px;
  text-align: center;
  font-size: 18px;
}

.business_but {
  width: 100%;
  height: 50px;
  border-radius: 30px;
  text-align: center;
  margin-top: 30px;
  line-height: 50px;
  //background: linear-gradient(to right,#FF6241,#FF6241,#FF3738);
  background-color: var(--bg-color);
  color: #fff;
}
</style>

